import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { SOFTLINE_CONFIG_SETTINGS } from '@softline/application';
import { LocalStorageDataAccess } from '@softline/core';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { AbcAnalysisRepository } from './repositories/abc-analysis.repository';
import { AbcAnalysisService } from './services/abc-analysis.service';
import {
  SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY,
  SOFTLINE_PERMISSION_ABC_ANALYSIS,
} from './abc-analysis.shared';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideABCAnalysisProviders (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideABCAnalysisGlobals(): Array<Provider | EnvironmentProviders> {
  return [
    {
      provide: SOFTLINE_CONFIG_SETTINGS,
      multi: true,
      useFactory: () => {
        const storage = inject(LocalStorageDataAccess);
        return {
          key: 'SOFTLINE_SETTINGS_ABC_ANALYSIS',
          component: ConfigurationComponent,
          title: '#ABC_ANALYSIS.CONFIGURATION.SETTINGS_TITLE',
          default: undefined,
          icon: 'fa-regular fa-chart-pie',
          group: 'module',
          permission: SOFTLINE_PERMISSION_ABC_ANALYSIS,
          visible: true,
          onReset: () => {
            const key = SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY;
            if (storage.get({ key }) !== null) {
              storage.delete({ key });
            }
          },
        };
      },
    },
    AbcAnalysisService,
    AbcAnalysisRepository,
  ];
}
